import React from "react";
import AdminDashboard from "./AdminDashboard";
import DispatcherDashboard from "./DispatcherDashboard";
import ErrorBoundary from './ErrorBoundary';

const Dashboard = () => {
    const role = sessionStorage.getItem("role");

    // Admin Dashboard
    if (role === "admin") {
        return (
            <ErrorBoundary componentName="AdminDashboard">
                <AdminDashboard />
            </ErrorBoundary>
        );
    }

    // Dispatcher Dashboard
    if (role === "dispatcher") {
        return (
            <ErrorBoundary componentName="DispatcherDashboard">
                <DispatcherDashboard />
            </ErrorBoundary>
        );
    }

    // Optional fallback
    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h2>Unauthorized Access</h2>
            <p>No dashboard available for this role.</p>
        </div>
    );
};

export default Dashboard;